export default __webpack_public_path__ + "static/media/Pistol_1.cd4e15ec.png";